import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import {IWindow} from '../index';
import { DropzoneComponent } from 'react-dropzone-component';

const Window = window as IWindow;
const reactToken = Window.initialState.react_token;

export class DropZoneStore {
    @observable progress = 0;
    @observable error = null;
    @observable uploadButtonEnabled = true;
    public dropzonejs: any;

    djsConfig = {
        maxFilesize: 6,
        acceptedFiles: '.xls,.xlsx',
        previewTemplate: '<span />',
        paramName: 'file',
        headers: {
            'X-CSRF-TOKEN': reactToken,
            Accept: 'application/json',
        },
        credentials: 'include',
        dictDefaultMessage: '',
        clickable: '.filepicker .btn',
    };

    componentConfig = {
        postUrl: '',
    };

    eventHandlers = {
        init: (dropzonejs: any) => {
            this.dropzonejs = dropzonejs;
        },
        sending: () => {
            this.uploadButtonEnabled = false;
        },
        totaluploadprogress: (totalProgress: any) => {
            this.progress = totalProgress;
        },
        error: (file: any, response: any) => {
            this.error = response.errors.file[0] || response.message || response;
            this.dropzonejs.removeAllFiles();
            this.uploadButtonEnabled = true;
            this.progress = 0;
        },
    };
}

interface IDropzoneProps {
    store: DropZoneStore;
    children?: any;
    componentConfig?: {};
    djsConfig?: {};
    eventHandlers?: {};
}

@observer
export default class DropZone extends React.Component<IDropzoneProps> {
    render() {
        const { children, store, componentConfig, djsConfig, eventHandlers } = this.props;
        if (componentConfig) {
            store.componentConfig = { ...store.componentConfig, ...componentConfig };
        }
        if (djsConfig) {
            store.djsConfig = { ...store.djsConfig, ...djsConfig };
        }
        if (eventHandlers) {
            store.eventHandlers = { ...store.eventHandlers, ...eventHandlers };
        }

        return (
            <>
                {store.error ? <div className="popup-messages redText">{store.error}</div> : null}
                <DropzoneComponent
                    config={store.componentConfig}
                    djsConfig={store.djsConfig}
                    eventHandlers={store.eventHandlers}
                    className="clearfix"
                >
                    {children}
                </DropzoneComponent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/stores/DropZoneStore.tsx